// Include main stylesheet (which is including bootstrap in a custom way)
//import 'masonry-layout';
// window.Masonry = require('masonry-layout');
// window.GoogleMapsLoader = require('google-maps');
//import MarkerClusterer from '@google/markerclusterer';

// import "bootstrap";
// import "bootstrap-select";
// import "bootstrap-select";
// import "jquery-visible";

require('../sass/main.scss');

// import 'slick-carousel';

// require('./load.js');
//require('./filters.js');
// require('./click.js');
// require('./forms.js');

//Format liste d'emploi
$('.btn-fmt-list').on('click', function (ev) {
    ev.preventDefault();
    if($('.btn-fmt-carre').hasClass('active'))
        $('.btn-fmt-carre').removeClass('active');
    $(this).toggleClass('active');

    var url=window.location.href,
    separator = (url.indexOf("?")===-1)?"?":'&',
    newParam=separator + "format_list=1";
    var newURL=url.replace(newParam,"");
    newURL+=newParam;
    history.pushState($('#filtersBoite').serialize(), '', newURL);
    $('#list').addClass('loading');
    $('#list').load(newURL + ' #list >', function () {
        $('#list').removeClass('loading');
    });
});

$('.btn-fmt-carre').on('click', function (ev) {
    ev.preventDefault();
    if($('.btn-fmt-list').hasClass('active'))
        $('.btn-fmt-list').removeClass('active');
    $(this).toggleClass('active');
    var url=window.location.href,
    separator = (url.indexOf("?")===-1)?"?":'&',
    newParam=separator + "format_list=0";
    var newURL=url.replace(newParam,"");
    newURL+=newParam;
    history.pushState($('#filtersBoite').serialize(), '', newURL);
    $('#list').addClass('loading');
    $('#list').load(newURL + ' #list >', function () {
        $('#list').removeClass('loading');
    });
});

$('.lost-pwd').on('click', function (ev) {
    ev.preventDefault();
    $("#initPwd").val(true);
    $("#loginform").submit();
  });


/* Uploaded files in forms - remove before upload */
$('.form-control-file').change( function(event) {
    var fileName = $(this).val().match(/[^\\/]*$/)[0];
    $('.uploadedFile', $(this).closest('.wpcf7-form-control-wrap')).remove();
    $(this).closest('.wpcf7-form-control-wrap').append('<div class="uploadedFile">'+ fileName +'<a class="removeFile" href="#" title="Remove"><i class="fa fa-times-circle"></i></a></div>');
});
$(document).on("click",".removeFile", function(e){
    e.preventDefault();
    $(this).closest('.wpcf7-form-control-wrap').find('input[type="file"]').val('')
    $(this).parent().remove();
});

$('.submitFormCv').on('click', function (ev) {
    ev.preventDefault();
    $("#fileCv").val($("#filelist").val());
    $("#cvform").submit();
  });

$('.submitFormCandidat').on('click', function (ev) {
  ev.preventDefault();
  $("#candidatform").submit();


});
$('.submitFormCandidature').on('click', function (ev) {
  ev.preventDefault();
  $("#candidatureform").submit();
});

$('.parent i').on('click', function(e) {
    e.preventDefault();
    if($(this).hasClass('fa-chevron-down')){
        $(this).removeClass('fa-chevron-down').addClass('fa-chevron-up');
        $(this).closest('.search-item').find('.subfilters').show();
    }else{
        $(this).removeClass('fa-chevron-up').addClass('fa-chevron-down');
        $(this).closest('.search-item').find('.subfilters').hide();
    }
});

$('.parent2 i').on('click', function(e) {
    e.preventDefault();
    if($(this).hasClass('fa-chevron-down')){
        $(this).removeClass('fa-chevron-down').addClass('fa-chevron-up');
        $(this).closest('.search-item').find('.subfilters2').show();
    }else{
        $(this).removeClass('fa-chevron-up').addClass('fa-chevron-down');
        $(this).closest('.search-item').find('.subfilters2').hide();
    }
});


//Si on check un parent, on check les enfants
$('.filters .parent .filter').on('click', function () {
    if(!$(this).hasClass('active')){
        $(this).closest('.search-item').find('.subfilters .filter').addClass('active');
        $(this).closest('.search-item').find('.subfilters input[type=checkbox]').prop( "checked", true );
    } else {
        $(this).closest('.search-item').find('.subfilters .filter').removeClass('active');
        $(this).closest('.search-item').find('.subfilters input[type=checkbox]').prop( "checked", false );
    }
});

//Si on décoche un enfant, on décoche le parent
$('.filters .subfilters .filter').on('click', function () {
    if($(this).hasClass('active')){
        $(this).closest('.search-item').find('.parent .filter').removeClass('active');
        $(this).closest('.search-item').find('.parent input[type=checkbox]').prop( "checked", false );
        $(this).closest('.filters-row').find('.parent .filter').removeClass('active');
        $(this).closest('.filters-row').find('.parent input[type=checkbox]').prop( "checked", false );
    }
});
$('.filters .parent2 .filter').on('click', function () {
    if(!$(this).hasClass('active')){
        $(this).closest('.search-item').find('.subfilters2 .filter').addClass('active');
        $(this).closest('.search-item').find('.subfilters2 input[type=checkbox]').prop( "checked", true );
    } else {
        $(this).closest('.search-item').find('.subfilters2 .filter').removeClass('active');
        $(this).closest('.search-item').find('.subfilters2 input[type=checkbox]').prop( "checked", false );
    }
});
//Si on décoche un enfant, on décoche le parent
$('.filters .subfilters2 .filter').on('click', function () {
    if($(this).hasClass('active')){
        $(this).closest('.search-item').find('.parent2 .filter').removeClass('active');
        $(this).closest('.search-item').find('.parent2 input[type=checkbox]').prop( "checked", false );
    }
});


var socialFloat = document.querySelector('.fixed-buttons');
var footer = document.querySelector('#main-footer');

function checkOffset() {
    function getRectTop(el){
        if(!el) return;
        var rect = el.getBoundingClientRect();
        return rect.top;
    }
    if(socialFloat && ((getRectTop(socialFloat) + document.body.scrollTop) + socialFloat.offsetHeight >= (getRectTop(footer) + document.body.scrollTop) - 10)) {
        socialFloat.style.position = 'absolute';
        socialFloat.style.bottom = 'auto';
    }
    if(socialFloat && (document.body.scrollTop + window.innerHeight < (getRectTop(footer) + document.body.scrollTop))) {
        socialFloat.style.position = 'fixed'; // restore when you scroll up
        socialFloat.style.bottom = '0';
    }
}

document.addEventListener("scroll", function(){
    checkOffset();
});

// revert main nav stickyness
$('#main-nav').hcSticky('destroy');

$('.single-actualites .article-breadcrumb, .single-references .article-breadcrumb, .page-template-template-case-studies .article-breadcrumb').hcSticky({
    stickTo: $('#main-content'),
    top: 0,
});


if(is_mobile !== true) {
    $('.page-template-template-case-studies #ref-filters').hcSticky({
        stickTo: $('#main-content'),
        top: 32,
    });
} else {
    $('.page-template-template-case-studies #ref-filters').hcSticky({
        stickTo: $('#main-content'),
        top: 25,
    });
}

$('.single-actualites .sidebar, .single-references .sidebar').hcSticky({
    stickTo: $('#main-content'),
    top: 88,
    responsive: {
        1500: {
            disable: true,
        }
    }
});

// Open social share button
$('.social-popup').on('click', function(ev) {
    ev.preventDefault()
    var url = $(this).attr('href')
    var options = 'toolbar=0,status=0,resizable=1,width=626,height=436'
    window.open(url,'sharer', options)
})

$("#search-form .header-search-submit").on("click", function(e){
    e.preventDefault();
    $("#search-form").toggleClass("open");
    if($("#search-form").hasClass('open')) {
        $("#search-form #search-field").trigger("focus");
    }
  });//click

  $('.sidebar-experts-slider-fixe').slick({
    slidesToShow: 1,
    infinite: true,
    prevArrow: $('.expert-controls-fixe .left'),
    nextArrow: $('.expert-controls-fixe .right'),
});

$('.header-mobile-icon .btn').on('click',function(e){
    e.preventDefault();
    var el = $(this).find('i');
    el.toggleClass('fa-bars').toggleClass('fa-times');
    if(el.hasClass('fa-bars')){
        $('.nav-container').hide();
    }else{
        $('.nav-container').show();
    }
});
$(window).on('click', function (e){
    if(!$(e.target).hasClass('btn-header-mobile-menu-new')){
        if($(e.target).parents('.nav-container').length == 0 && $('.header-mobile-menu-new').hasClass('fa-times')){
            $('.header-mobile-menu-new').toggleClass('fa-bars').toggleClass('fa-times');
            $('.nav-container').hide();
        }
    }
});

document.getElementById("btn-back").addEventListener("click", () => {
    history.back();
});

if( $('body').hasClass('single-actualites') ||  $('body').hasClass('single-references') ){
    // When the user scrolls the page, execute myFunction
    window.onscroll = function() {progressBarScroll()};
}

function progressBarScroll() {
    var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    var scrolled = (winScroll / height) * 100;
    $('#progress-bar').css('width', scrolled + '%');
}
